/**
 * Column registry for the Page list view — drives "Configure the view".
 * `key` matches each antd column's `key` in List.tsx (the Domain column's key
 * is "content" for legacy reasons). Client-hide module.
 * See VIEW_CONFIG_INVENTORY.md §2.
 */

import { t } from "@/languages/i18n"
import type { ColumnMeta } from "@/(admin)/components/view-config"

export const pageColumnsRegistry: ColumnMeta[] = [
  { key: "name", title: t("Name"), defaultVisible: true, alwaysOn: true, sortable: true },
  { key: "content", title: t("Domain"), defaultVisible: true, sortable: true },
  { key: "Language", title: t("Language"), defaultVisible: true, sortable: true },
  { key: "createdAt", title: t("Create At"), defaultVisible: true, sortable: true },
  { key: "status", title: t("Trạng thái"), defaultVisible: true, sortable: true },
  // Phase 5 — codegen fields (hidden by default).
  { key: "title", title: t("Tiêu đề"), defaultVisible: false, type: "text", dataIndex: ["attributes", "title"], sortable: true },
  { key: "slug", title: t("Đường dẫn"), defaultVisible: false, type: "text", dataIndex: ["attributes", "slug"], sortable: true },
  { key: "author", title: t("Tác giả"), defaultVisible: false, type: "rel", dataIndex: ["attributes", "author"], queryPopulate: { author: { fields: ["username"] } } },
  { key: "isUseUIBuilder", title: t("Dùng UI Builder"), defaultVisible: false, type: "bool", dataIndex: ["attributes", "isUseUIBuilder"], sortable: true },
  { key: "updatedAt", title: t("Ngày cập nhật"), defaultVisible: false, type: "date", dataIndex: ["attributes", "updatedAt"], sortable: true },
  { key: "action", title: t("Hành động"), defaultVisible: true, alwaysOn: true },
]
